/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Meta_Twitterdescription1Inputs */

const ja_work_meta_twitterdescription1 = /** @type {(inputs: Work_Meta_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINが手がけたゲームマーケティング、eスポーツ、クリエイティブ制作の実績をご紹介します。マーケティング戦略、クリエイティブ制作、デジタル体験、イベント、ライブ配信、eスポーツなど、ゲーム業界を代表する企業とのプロジェクトをご覧ください。`)
};

const en_work_meta_twitterdescription1 = /** @type {(inputs: Work_Meta_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore selected projects from PLAYBRAIN's game marketing, esports, and creative portfolio. Discover campaigns for leading game publishers and gaming brands across marketing strategy, creative production, digital experiences, events, livestreams, and esports.`)
};

/**
* | output |
* | --- |
* | "Explore selected projects from PLAYBRAIN's game marketing, esports, and creative portfolio. Discover campaigns for leading game publishers and gaming brands ..." |
*
* @param {Work_Meta_Twitterdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const work_meta_twitterdescription1 = /** @type {((inputs?: Work_Meta_Twitterdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Meta_Twitterdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_meta_twitterdescription1(inputs)
	return en_work_meta_twitterdescription1(inputs)
});
export { work_meta_twitterdescription1 as "work_meta_twitterDescription" }